export type PerkId =
  | "pf"
  | "health_insurance"
  | "food_allowance"
  | "esi"
  | "travel_allowance"
  | "weekly_payout"
  | "overtime_pay"
  | "joining_bonus"
  | "annual_bonus"
  | "laptop"
  | "mobile_allowance"
  | "internet_allowance"
  | "night_shift_allowance"
  | "five_working_days"
  | "cab_facility"
  | "gym_membership";

export interface PerkCatalogEntry {
  id: PerkId;
  label: string;
}

export const PERK_CATALOG: readonly PerkCatalogEntry[] = [
  { id: "pf", label: "PF" },
  { id: "health_insurance", label: "Health Insurance" },
  { id: "food_allowance", label: "Food Allowance" },
  { id: "esi", label: "ESI" },
  { id: "travel_allowance", label: "Travel Allowance" },
  { id: "weekly_payout", label: "Weekly Payout" },
  { id: "overtime_pay", label: "Overtime Pay" },
  { id: "joining_bonus", label: "Joining Bonus" },
  { id: "annual_bonus", label: "Annual Bonus" },
  { id: "laptop", label: "Laptop" },
  { id: "mobile_allowance", label: "Mobile Allowance" },
  { id: "internet_allowance", label: "Internet Allowance" },
  { id: "night_shift_allowance", label: "Night Shift Allowance" },
  { id: "five_working_days", label: "5 Working Days" },
  { id: "cab_facility", label: "Cab Facility" },
  { id: "gym_membership", label: "Gym Membership" },
] as const;

export const PERK_LABELS: Record<string, string> = Object.fromEntries(
  PERK_CATALOG.map((perk) => [perk.id, perk.label]),
);

export function perkLabels(ids: string[]): string[] {
  return ids.map((id) => PERK_LABELS[id] ?? id);
}
